var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeroImageWrapper',[_c('Box',[_c('template',{slot:"header"},[_vm._v("Page Not Found!")]),_c('template',{slot:"body"},[_c('Paragraph',[_vm._v("\n        Sorry! The page you're looking for doesn't exist.\n      ")]),_c('LinkButton',{staticClass:"go-to-homepage",attrs:{"name":"goToHomePage","label":"Go to homepage","href":_vm.routes.HOME}})],1)],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8e25c8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound/NotFound.vue
// module id = null
// module chunks = 